enum SubscriptionStatus {
  // ── existing entries — do not change ──────────────────────────────────────
  Active = 'active',
  Canceled = 'canceled',
  Paused = 'paused',

  // ── new Paddle-only statuses ───────────────────────────────────────────────
  PauseScheduled = 'pause-scheduled',          // scheduled to pause at period end
  InProgress = 'inProgress',                   // upgrade/transaction being processed
  PaymentActionRequired = 'payment-action-required',  // SCA or card update required
  Inactive = 'inactive',
}

export default SubscriptionStatus;
